import LandingPage from './LandingPage';

export default function LegacyApp() {
  return <LandingPage />;
}
